import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { clearDatesFromStorage } from '../utils/dateStorage';

/**
 * Hook to clear booking-related data when navigating away from booking flow
 */
export const useNavigationCleanup = () => {
  const location = useLocation();
  const previousPath = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    const bookingRelatedPaths = ['/booking', '/product/'];
    
    // Check if we're leaving a booking-related page to a non-booking page
    const wasOnBookingPage = bookingRelatedPaths.some(path => previousPath.current.startsWith(path));
    const isOnNonBookingPage = !bookingRelatedPaths.some(path => currentPath.startsWith(path));
    
    // Clear dates only when transitioning from booking flow to non-booking flow
    if (wasOnBookingPage && isOnNonBookingPage) {
      clearDatesFromStorage();
    }
    
    // Update previous path for next comparison
    previousPath.current = currentPath;
  }, [location.pathname]);
};
